import { all } from 'redux-saga/effects';
import * as auth from './auth.saga';
import * as booklet from './booklet.saga';
import * as bookletList from './booklet-list.saga';
import * as bookletArchive from './booklet-archive.saga';
import * as bookletTags from './booklet-tags.saga';
import * as users from './users.saga';
import * as fragment from './fragment.saga';
import * as user from './user.saga';
import * as section from './section.saga';
import * as comment from './comment.saga';
import * as archive from './archive.saga';
import * as restore from './restore.saga';
import * as vote from './vote.saga';
import * as shares from './shares.saga';
import * as events from './events.saga';
import * as folder from './folder.saga';
import * as extension from './extension.saga';
import * as extensions from './extensions.saga';
import * as presentations from './presentations.saga';
import * as presentation from './presentation.saga';

// Single entry point to start all Sagas at once
export default function* rootSaga() {
  yield all([
    auth.loginRequest(),
    auth.logoutRequest(),
    auth.authFailure(),
    booklet.fetchBooklet(),
    booklet.saveBooklet(),
    booklet.createNewBooklet(),
    booklet.printBooklet(),
    booklet.fetchBookletShared(),
    booklet.removeBookletHeroImage(),
    bookletList.fetchBookletList(),
    bookletArchive.fetchBookletArchive(),
    bookletTags.fetchTagsByQuery(),
    bookletTags.toggleTag(),
    bookletTags.fetchAllTags(),
    users.fetchUsers(),
    users.deleteUser(),
    users.toggleUserActive(),
    users.saveUser(),
    users.fetchUser(),
    user.fetchCurrentUser(),
    fragment.saveFragment(),
    fragment.deleteFragment(),
    fragment.addFragment(),
    fragment.editChildFragment(),
    fragment.addChildFragment(),
    fragment.deleteChildFragment(),
    fragment.deleteGalleryImage(),
    fragment.addGalleryImages(),
    section.editSection(),
    section.deleteSection(),
    section.editSectionLayout(),
    section.saveSection(),
    comment.addComment(),
    comment.editComment(),
    comment.deleteComment(),
    archive.setArchived(),
    archive.deleteBooklet(),
    restore.setRestored(),
    vote.vote(),
    vote.deleteVote(),
    shares.addPersonalShare(),
    shares.fetchShares(),
    shares.addShare(),
    shares.editShare(),
    shares.deleteShare(),
    shares.refreshShare(),
    shares.refreshPresentationShareToken(),
    events.fetchEvents(),
    folder.fetchFolders(),
    folder.deleteFolder(),
    folder.addFolder(),
    folder.editFolder(),
    extension.saveExtension(),
    extension.fetchExtension(),
    extensions.fetchExtensions(),
    extensions.deleteExtension(),
    extensions.searchExtensions(),
    extensions.searchExtensionsByName(),
    extensions.fetchExtensionsTags(),
    extensions.toggleExtensionsTag(),
    extensions.moveExtensionFile(),
    presentation.fetchPresentation(),
    presentation.fetchPresentationShares(),
    presentation.favouriteShare(),
    presentation.removeShare(),
    presentation.selectExtensionToSelectMediaDialog(),
    presentation.savePresentation(),
    presentation.addExtensionToPresentation(),
    presentation.fetchSharedPresentation(),
    presentation.removeExtensionFromPresentation(),
    presentation.editPresentation(),
    presentation.addNewPresentation(),
    presentations.fetchPresentations(),
    presentations.deletePresentation(),
    presentations.searchPresentations(),
  ]);
}



// WEBPACK FOOTER //
// ./src/sagas/sagas.js